// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contacts-email-wall {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--theme-overlay-bg);
  -webkit-backdrop-filter: blur(4px);
          backdrop-filter: blur(4px);
  z-index: 10;
}
.contacts-email-wall__card {
  display: flex;
  flex-direction: column;
  width: 400px;
  background: var(--theme-modal-bg);
  border: 1px solid var(--theme-modal-border);
  border-radius: var(--radius-lg);
  box-shadow: var(--theme-shadow-strong);
  overflow: hidden;
}
.contacts-email-wall__header {
  display: flex;
  align-items: center;
  gap: var(--space-md);
  padding: 24px 28px 20px;
  border-bottom: 1px solid var(--theme-border-primary);
  background: var(--theme-bg-secondary);
}
.contacts-email-wall__gmail-icon {
  color: var(--theme-primary);
  flex-shrink: 0;
}
.contacts-email-wall__title {
  font-size: 15px;
  font-weight: var(--font-weight-semibold);
  color: var(--theme-text-primary);
  margin: 0 0 2px;
  line-height: 1.3;
}
.contacts-email-wall__subtitle {
  font-size: var(--font-size-sm);
  color: var(--theme-text-muted);
  margin: 0;
}
.contacts-email-wall__body {
  font-size: var(--font-size-md);
  color: var(--theme-text-secondary);
  line-height: 1.6;
  margin: 0;
  padding: 20px 28px 0;
}
.contacts-email-wall__features {
  list-style: none;
  margin: 0;
  padding: 16px 28px 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.contacts-email-wall__features li {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: var(--font-size-md);
  color: var(--theme-text-secondary);
}
.contacts-email-wall__feature-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: var(--radius-sm);
  background: var(--theme-primary-soft);
  color: var(--theme-primary);
  flex-shrink: 0;
}
.contacts-email-wall__footer {
  padding: 24px 28px;
}
.contacts-email-wall__btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-sm);
  width: 100%;
  padding: 10px 20px;
  border-radius: var(--radius-md);
  border: none;
  background: var(--theme-primary);
  color: var(--theme-primary-contrast);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  cursor: pointer;
  box-shadow: var(--theme-shadow-subtle);
  transition: background 0.12s, transform 0.12s, box-shadow 0.12s;
}
.contacts-email-wall__btn:hover:not(:disabled) {
  background: var(--theme-primary-hover);
  transform: translateY(-1px);
  box-shadow: var(--theme-shadow-soft);
}
.contacts-email-wall__btn:active {
  transform: translateY(0);
  box-shadow: var(--theme-shadow-subtle);
}
.contacts-email-wall__btn:disabled {
  opacity: 0.65;
  cursor: not-allowed;
  transform: none;
}
.contacts-email-wall__btn-icon {
  opacity: 0.9;
  flex-shrink: 0;
}
.contacts-email-wall__spinner {
  animation: contacts-email-wall-spin 0.9s linear infinite;
}

@keyframes contacts-email-wall-spin {
  to {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/apps/ContactsApp/components/ContactsEmailWall/ContactsEmailWall.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mCAAA;EACA,kCAAA;UAAA,0BAAA;EACA,WAAA;AACF;AACE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,iCAAA;EACA,2CAAA;EACA,+BAAA;EACA,sCAAA;EACA,gBAAA;AACJ;AAEE;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,uBAAA;EACA,oDAAA;EACA,qCAAA;AAAJ;AAGE;EACE,2BAAA;EACA,cAAA;AADJ;AAIE;EACE,eAAA;EACA,wCAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;AAFJ;AAKE;EACE,8BAAA;EACA,8BAAA;EACA,SAAA;AAHJ;AAME;EACE,8BAAA;EACA,kCAAA;EACA,gBAAA;EACA,SAAA;EACA,oBAAA;AAJJ;AAOE;EACE,gBAAA;EACA,SAAA;EACA,oBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AALJ;AAOI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,8BAAA;EACA,kCAAA;AALN;AASE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,+BAAA;EACA,qCAAA;EACA,2BAAA;EACA,cAAA;AAPJ;AAUE;EACE,kBAAA;AARJ;AAWE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,WAAA;EACA,kBAAA;EACA,+BAAA;EACA,YAAA;EACA,gCAAA;EACA,oCAAA;EACA,8BAAA;EACA,wCAAA;EACA,eAAA;EACA,sCAAA;EACA,+DAAA;AATJ;AAWI;EACE,sCAAA;EACA,2BAAA;EACA,oCAAA;AATN;AAYI;EACE,wBAAA;EACA,sCAAA;AAVN;AAaI;EACE,aAAA;EACA,mBAAA;EACA,eAAA;AAXN;AAeE;EACE,YAAA;EACA,cAAA;AAbJ;AAgBE;EACE,wDAAA;AAdJ;;AAkBA;EACE;IAAK,yBAAA;EAdL;AACF","sourcesContent":[".contacts-email-wall {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--theme-overlay-bg);\n  backdrop-filter: blur(4px);\n  z-index: 10;\n\n  &__card {\n    display: flex;\n    flex-direction: column;\n    width: 400px;\n    background: var(--theme-modal-bg);\n    border: 1px solid var(--theme-modal-border);\n    border-radius: var(--radius-lg);\n    box-shadow: var(--theme-shadow-strong);\n    overflow: hidden;\n  }\n\n  &__header {\n    display: flex;\n    align-items: center;\n    gap: var(--space-md);\n    padding: 24px 28px 20px;\n    border-bottom: 1px solid var(--theme-border-primary);\n    background: var(--theme-bg-secondary);\n  }\n\n  &__gmail-icon {\n    color: var(--theme-primary);\n    flex-shrink: 0;\n  }\n\n  &__title {\n    font-size: 15px;\n    font-weight: var(--font-weight-semibold);\n    color: var(--theme-text-primary);\n    margin: 0 0 2px;\n    line-height: 1.3;\n  }\n\n  &__subtitle {\n    font-size: var(--font-size-sm);\n    color: var(--theme-text-muted);\n    margin: 0;\n  }\n\n  &__body {\n    font-size: var(--font-size-md);\n    color: var(--theme-text-secondary);\n    line-height: 1.6;\n    margin: 0;\n    padding: 20px 28px 0;\n  }\n\n  &__features {\n    list-style: none;\n    margin: 0;\n    padding: 16px 28px 0;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n\n    li {\n      display: flex;\n      align-items: center;\n      gap: 10px;\n      font-size: var(--font-size-md);\n      color: var(--theme-text-secondary);\n    }\n  }\n\n  &__feature-icon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 24px;\n    height: 24px;\n    border-radius: var(--radius-sm);\n    background: var(--theme-primary-soft);\n    color: var(--theme-primary);\n    flex-shrink: 0;\n  }\n\n  &__footer {\n    padding: 24px 28px;\n  }\n\n  &__btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: var(--space-sm);\n    width: 100%;\n    padding: 10px 20px;\n    border-radius: var(--radius-md);\n    border: none;\n    background: var(--theme-primary);\n    color: var(--theme-primary-contrast);\n    font-size: var(--font-size-md);\n    font-weight: var(--font-weight-semibold);\n    cursor: pointer;\n    box-shadow: var(--theme-shadow-subtle);\n    transition: background 0.12s, transform 0.12s, box-shadow 0.12s;\n\n    &:hover:not(:disabled) {\n      background: var(--theme-primary-hover);\n      transform: translateY(-1px);\n      box-shadow: var(--theme-shadow-soft);\n    }\n\n    &:active {\n      transform: translateY(0);\n      box-shadow: var(--theme-shadow-subtle);\n    }\n\n    &:disabled {\n      opacity: 0.65;\n      cursor: not-allowed;\n      transform: none;\n    }\n  }\n\n  &__btn-icon {\n    opacity: 0.9;\n    flex-shrink: 0;\n  }\n\n  &__spinner {\n    animation: contacts-email-wall-spin 0.9s linear infinite;\n  }\n}\n\n@keyframes contacts-email-wall-spin {\n  to { transform: rotate(360deg); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
